// #region Imports
//Components    
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-text-field',
    mixins: [host.mixins.form],
    props: {
        inputAttr: {
            type: Object,
            required: false,
            default: null,
        },
        mode: {
            type: String,
            required: false,
            default: 'text',
            validValues: ['text', 'password', 'email', 'phone', 'number'],
            validator(value) {
                if (!value.length) {
                    return true;
                }
                return ['text', 'password', 'email', 'phone', 'number'].includes(value);
            }
        },
        maxLength: {
            type: Number,
            required: false,
            default: 0,
        },
        autocomplete: {
            type: String,
            required: false,
            default: '',
        },
        showClearButton: {
            type: Boolean,
            required: false,
            default: false
        },
        updateLazy: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data: () => ({
        showPassword: false
    }),
    computed: {
        inputAttrInternal() {
            return this.inputAttr;
        },
        modeInternal() {
            if (this.mode === 'password' && this.showPassword) {
                return 'text';
            }
            else if (this.mode == 'email') {
                return 'email';
            }
            else if (this.mode == 'phone') {
                return 'tel';
            }
            else {
                return this.mode;
            }
        },
        passwortButtonIcon() {
            if (!this.showPassword) {
                return '/assets/icons/eye-slash-fill.svg';
            }
            else {
                return '/assets/icons/eye.svg';
            }
        },
        emailButtonIcon() {
            return '/assets/icons/at.svg';
        },
        phoneButtonIcon() {
            return '/assets/icons/telephone.svg';
        },
    },
    methods: {
        onEnterKey(event) {
            if (event.keyCode === 13) {
                this.$emit('EnterKey', event);
            }
        },
        tooglePassword() {
            this.showPassword = !this.showPassword;
        }
    }
});
// #endregion
